<template>
<iframe src="https://www.wenhua.com.cn/popwin/footer_wenhua.html" frameborder="0" style="min-width: 1400px;width: 100%;height: 64px;margin: 0 auto;display:block"></iframe>
</template>

<script>
// import ResTxt from '@/ResData/ResTxt'
export default {
  // components: {
  //   ResTxt
  // },
  data(){
    return{
    }
  },
};
</script>

<style>
.wh8footer {
  /* position: absolute;
  bottom: 0; */
  text-align: center;
  min-width: 1400px;
  width: 100%;

  min-height: 64px;

  margin: 0 auto;
  background-color: #010334;
  color: #e8e9ed;
  font-size: 12px;
  line-height: 20px;
}
</style>